import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';

import { AppinfoService } from '../../../../../common-services/appinfo.service';
import { CommonFunctionService } from '../../../../../common-services/common-function.service';
import { MappingSystemColumn, SystemColumnOption } from '../ninja-meta.component';
import { NinjaEventLayer, SettingsNinjaService, NinjaSystemColumnsMapping, NinjaDefaultsEventLayerConfig, NinjaDefaults, NinjaSystemColumnMappingMethod, NinjaSystemColumnsTemplate, NinjaDefaultsEventLayersConfig } from '../../../../../common-services/settings-ninja.service';
import { AppSettings } from '../../../../../app.settings';

export interface ModalNinjaSystemColumnsTemplateInput {
	systemColumns: MappingSystemColumn[];
}
export interface ModalNinjaSystemColumnsTemplateOutput {
	layers: NinjaDefaultsEventLayersConfig;
	template: NinjaSystemColumnsTemplate;
}

@Component({
	selector: 'app-ninja-system-columns-template',
	templateUrl: './ninja-system-columns-template.component.html',
	styleUrls: ['./ninja-system-columns-template.component.css', '../ninja-meta.component.css']
})
export class NinjaSystemColumnsTemplateComponent implements OnInit {

	public systemColumns: MappingSystemColumn[];
	public systemColumnOptions: SystemColumnOption[];

	public selectedTemplateLayer: NinjaEventLayer;
	public eventLayers: NinjaEventLayer[];

	public hasChanged: boolean;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: ModalNinjaSystemColumnsTemplateInput,
		public dialogRef: MatDialogRef<NinjaSystemColumnsTemplateComponent>,
		private toastr: ToastrService,
		private appinfoService: AppinfoService,
		private commonService: CommonFunctionService,
		private ninjaService: SettingsNinjaService
	) { }

	public onSelectTemplateLayer() {
		this.hasChanged = true;
		this.setSystemColumns(this.selectedTemplateLayer.name);
	}

	public onMapSystemColumn(sysCol: MappingSystemColumn) {
		this.systemColumnOptions.forEach(o => {
			if (o.name === sysCol.mappedCol) {
				o.mappedSystemAttr = sysCol.attrValue;
			} else if (o.mappedSystemAttr === sysCol.attrValue) {
				o.mappedSystemAttr = null;
			}
		});
		this.systemColumns.forEach(s => {
			if (s.attrValue !== sysCol.attrValue) {
				if (s.mappedCol === sysCol.mappedCol) {
					s.mappedCol = null;
				} 
			}
		});
		const option = this.systemColumnOptions.find(o => o.name === sysCol.mappedCol);
		option.mappedSystemAttr = sysCol.attrValue;
		this.hasChanged = true;
	}

	// Set system columns mapping and options
	private setSystemColumns(layerName?) {
		const storedConfig: NinjaDefaultsEventLayerConfig = this.ninjaService.ninjaDefaults.eventLayers ? this.ninjaService.ninjaDefaults.eventLayers[layerName] : null;
		const result = this.ninjaService.getSystemColumnsMappingAndOptions(layerName, storedConfig);
		this.systemColumns = result.systemColumns;
		this.systemColumnOptions = result.systemColumnOptions;
	}
	public async apply() {
		// Update system columns
		let templateMapping: NinjaSystemColumnsMapping = {};
		const templateMappingCols = [];
		this.systemColumns.forEach(c => {
			if (c.mappedCol) {
				templateMapping[c.attrValue] = c.mappedCol;
				templateMappingCols.push(c.mappedCol);
			}
		});
		const defaults: NinjaDefaults = JSON.parse(JSON.stringify(this.ninjaService.ninjaDefaults)) || {};
		defaults.eventLayers = defaults.eventLayers || {};;
		//
		const template = {
			mapping: templateMapping
		}
		// Update layers config according to the change of template mapping
		const layers: NinjaDefaultsEventLayersConfig = {};
		this.eventLayers.forEach(layer => {				
			const storedConfig = defaults.eventLayers[layer.name] || {
				systemColumns: null,
				columns: null
			};
			const updatedConfig: NinjaDefaultsEventLayerConfig = {
				systemColumns: {
					mappingMethod: null,
					mapping: null
				},
				columns: storedConfig.columns,
			};
			let mappingMethod: NinjaSystemColumnMappingMethod;
			// If systemColumnsMapping is customized, keep existing value
			if (storedConfig.systemColumns && storedConfig.systemColumns.mappingMethod === 'customized') {
				updatedConfig.systemColumns.mapping = storedConfig.systemColumns.mapping;
				// Check if the customized values are the same as template
				const isSame = !Object.keys(templateMapping).find(key => {
					return storedConfig.systemColumns.mapping[key] !== templateMapping[key];
				});
				if (isSame) {
					mappingMethod = 'standard';
				} else {
					mappingMethod = 'customized';
				}
			} else {
				// Check if layer has all the columns needed in standard mapping
				const missingCol = templateMappingCols.find(s => {
					const field = layer.fields.find(f => f.name === s);
					return !field;
				});
				if (!missingCol) {
					mappingMethod = 'standard';
				} else {
					mappingMethod = 'missing';
				}
			}
			updatedConfig.systemColumns.mappingMethod = mappingMethod;
			layers[layer.name] = updatedConfig;
		});
		//

		const data: ModalNinjaSystemColumnsTemplateOutput = {
			layers: layers,
			template: template
		};
		this.dialogRef.close(data);
	}
	public cancel() {
		this.dialogRef.close();
	}

	ngOnInit() {
		this.eventLayers = this.ninjaService.eventLayers;

		this.systemColumns = JSON.parse(JSON.stringify(this.data.systemColumns));
	}

}



// WEBPACK FOOTER //
// ./src/app/components/portal/settings-ninja/ninja-meta/ninja-system-columns-template/ninja-system-columns-template.component.ts